import { useEffect, useState } from "react";
import { ConfigService } from "../services/ConfigService";
import { useFetch } from "./useFetch";

type ConfigProps = {
  name: string;
  value: boolean;
};

type ConfigPropsString = {
  name: string;
  value: string;
};

type BusinessMessage = {
  type: string;
  title: string;
  subtitle?: string;
  message: string;
};

type ConfigResponse = {
  businessRules: ConfigProps[];
  urls: ConfigPropsString[];
  socialNetworks: ConfigProps[];
  appStores: ConfigPropsString[];
  appStoresLatestVersion: ConfigProps[];
  partners_urls: ConfigProps[];
  partnersGooglePlay: ConfigPropsString[];
  partnersAppStore: ConfigPropsString[];
  businessMessages: BusinessMessage[];
};

interface IConfig {
  productsUrl: string;
}

export function useConfig() {
  const [config, setConfig] = useState<IConfig>();

  const { data: configData } = useFetch<ConfigResponse>(
    ConfigService.getConfig
  );

  useEffect(() => {
    const urls = configData?.urls.find((url) => url.name === "products")?.value;

    setConfig({ productsUrl: urls! });
  }, [configData]);

  return {
    config,
  };
}
